export const viewports = {
    max: 1355,
    large: 1024,
    mid: 768,
    small: 320
  }